import React from 'react';

import { Box, Loader, Paper, Stack, Text, Title } from '@mantine/core';

interface FinishingUpOverlayProps {
  visible: boolean;
}

// Spec Item 1 "Finishing up…": bridges the checkout POST and the confirmation render.
// Rendered by the Order Summary (which owns the in-flight request) so the accordion —
// and the mutation callbacks bound to it — stay mounted underneath.
const FinishingUpOverlay = ({ visible }: FinishingUpOverlayProps): JSX.Element | null => {
  if (!visible) return null;

  return (
    <Box
      role='status'
      aria-live='polite'
      data-cy='finishingUpOverlay'
      sx={theme => ({
        position: 'fixed',
        inset: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing.md,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
      })}
    >
      <Paper shadow='md' radius='md' withBorder p='xl' maw={440}>
        <Stack align='center' spacing='sm'>
          <Loader />
          <Title order={3} align='center'>
            Finishing up…
          </Title>
          <Text size='sm' color='dimmed' align='center'>
            Confirming your order — don&apos;t close this window. Your payment went through and you
            won&apos;t be charged twice.
          </Text>
        </Stack>
      </Paper>
    </Box>
  );
};

export default FinishingUpOverlay;
